import type { ApprovalDecision } from "~/components/tool-ui/approval-card";
import type { HitlToolProps } from "./hitlTools";
import type { ToolCallEntry } from "./useTurns";

// Derives the ApprovalCard interaction props shared by every approval-style HITL
// card (`ask_for_approval`, `confirm_ingest`): the prior decision as `choice`,
// plus approve/deny handlers that resume the paused run via `onAnswer`. The
// handlers are undefined in read-only views (no `onAnswer`), which disables the
// buttons; a rejected `onAnswer` re-enables them so retry just works.
export function approvalWiring(entry: ToolCallEntry, onAnswer: HitlToolProps["onAnswer"]) {
  return {
    choice: entry.result as ApprovalDecision | undefined,
    onConfirm: onAnswer ? () => onAnswer(entry.id, "approved") : undefined,
    onCancel: onAnswer ? () => onAnswer(entry.id, "denied") : undefined,
  };
}
